import {ApiError} from '../api';

export function getDropinErrorMessage(err: ApiError): string | null {
  let msg = null;

  console.log('API ERR OBJ', {...err});

  // The following errorCodes should be translated in the backend.
  // However, since we're using "our" self-built subscription management for only a few further months we're translating them in the frontend because it's easier.
  // TODO: translate in backend once new subscription management is there.
  const eCodeStr = err.code as string;
  if (
    err.code === 'payment/payRefused' ||
    eCodeStr === 'payment_payRefused' ||
    err.code === 'payment/payUnsuccessful' ||
    eCodeStr === 'payment_payUnsuccessful' ||
    err.code === 'payment/paymentProvider' ||
    eCodeStr === 'payment_paymentProvider'
  ) {
    msg = 'Die Zahlung konnte nicht abgeschlossen werden. ';

    switch (err.data.refusalReason) {
      case 'Blocked Card':
        msg +=
          'The card used for the transaction is blocked, therefore unusable.';
        break;
      case 'Shopper Cancelled':
        msg += 'The transaction was cancelled.';
        break;
      case 'Cancelled':
        msg += 'The transaction was cancelled.';
        break;
      case 'CVC Declined':
        msg += 'The CVC/CVV Code was invalid.';
        break;
      case 'Refused':
        msg += 'The transaction was refused.';
        break;
      case 'Acquirer Error':
        msg +=
          "The transaction did not go through due to an error that occurred on the acquirer's end.";
        break;
      case 'Expired Card':
        msg +=
          'The card used for the transaction has expired. Therefore it is unusable.';
        break;
      case 'Invalid Card Number':
        msg += 'The specified card number is incorrect or invalid.';
        break;
      case 'Invalid Pin':
        msg += 'The specified PIN number is incorrect or invalid.';
        break;
      case 'Not enough balance':
        msg +=
          'The card does not have enough money to cover the payable amount.';
        break;
      case '3d-secure: Authentication failed':
        msg += '3D Secure authentication was not successfully.';
        break;
      case '3D Not Authenticated':
        msg += '3D Secure authentication was not successfully.';
        break;
      default:
        msg +=
          'Bitte prüfe, ob alle eingegebenen Informationen korrekt sind. Wenn der Vorgang dennoch nicht funktioniert probiere es bitte später noch einmal.';
    }
  }

  return msg;
}
